import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["button", "amenitiesToggle"];

  connect() {
    this.moreAmenitiesText = this.amenitiesToggleTarget.innerText;
  }

  toggleReadMore() {
    this.element.classList.toggle("is-open");
    let flip = {
      "read more": "Read Less",
      "read less": "Read More"
    };
    this.buttonTarget.innerText =
      flip[this.buttonTarget.innerText.toLowerCase()];
  }

  toggleAmenities() {
    this.element.classList.toggle("more-amenities");
    let text = {};
    text["- Show Fewer Amenities"] = this.moreAmenitiesText;
    text[this.moreAmenitiesText] = "- Show Fewer Amenities";
    this.amenitiesToggleTarget.innerText =
      text[this.amenitiesToggleTarget.innerText];
  }
}
